module.exports = __webpack_public_path__ + "static/media/payrollCalender.f182ca50.svg";